var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrap"},[_c('header-component'),_c('main',{attrs:{"id":"view view--404"}},[_c('h2',{staticClass:"page-heading"},[_vm._v("404")]),_c('p',[_vm._v("Page not found.")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home -->")])],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }